import script from "./ViewATeam.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewATeam.vue?vue&type=script&setup=true&lang=js"

import "./ViewATeam.vue?vue&type=style&index=0&id=082a14d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082a14d2"]])

export default __exports__